import { render, staticRenderFns } from "./FAQMobileDropDown.vue?vue&type=template&id=1c12cb36&scoped=true&"
import script from "./FAQMobileDropDown.vue?vue&type=script&lang=js&"
export * from "./FAQMobileDropDown.vue?vue&type=script&lang=js&"
import style0 from "./FAQMobileDropDown.vue?vue&type=style&index=0&id=1c12cb36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c12cb36",
  null
  
)

export default component.exports